/** VUE 3 UPGRADE */
import { createApp } from 'vue';
import { createPinia } from 'pinia';

const pinia = createPinia();

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
// *** THIS IS POTENTIALLY LEGACY CODE FROM VUE 2
require('./bootstrap');
require('./custom');
require('./altos/scripts');
// *** THIS IS POTENTIALLY LEGACY CODE FROM VUE 2

// IMPORT ALL COMPONETS FOR VUE 3
import flash from './components/FlashEventComponent.vue';
import checkoutPage from './pages/checkout-page.vue';
import cartItemCount from './components/cart/CartItemCountComponent.vue';
import cartAddToCart from './components/cart/CartAddToCartComponent.vue';
import dataCastAddToCart from './components/cart/DataCastAddToCartComponent.vue';
import cart from './components/cart/CartComponent.vue';
import clickToEdit from './components/user/ClickToEditComponent.vue';
import clickToEditPassword from './components/user/ClickToEditPasswordComponent.vue';
import requestPasswordChange from './components/user/RequestPasswordChangeComponent.vue';
import userBillingInfo from './components/user/BillingInfoComponent.vue';
import payInvoice from './components/user/Invoices/InvoiceLookupComponent.vue';
import contactUs from './components/contactForms/ContactUsComponent.vue';
import contactCustomerCare from './components/contactForms/ContactCustomerCareComponent.vue';
import datacastTrialList from './components/datacast/TrialListComponent.vue';
import trendsReportTrialList from './components/trendsreport/TrialListComponent.vue';
import insiderLeadingIndicatorsList from './components/insider/LeadingIndicatorsListComponent.vue';
import insiderCancellationOptions from './components/dashboard/subscriptions/insider/InsiderCancellationOptionsComponent.vue';
import trendsreportCancellationOptions from './components/dashboard/subscriptions/trendsreport/TrendsreportCancellationOptionsComponent.vue';
import datacastCancellationOptions from './components/dashboard/subscriptions/datacast/DataCastCancellationOptionsComponent.vue';
import datacastEssentialsCancellationOptions from './components/dashboard/subscriptions/datacast/DataCastEssentialsCancellationOptionsComponent.vue';
import newUserExperienceModal from './components/user/NewUserExperienceModal.vue';
import report from './components/report/ReportComponent.vue';
import appReport from './components/report/AppReportComponent.vue';
import reportByID from './components/report/ReportByIDComponent.vue';
import reportByIDWithRegion from './components/report/ReportByIDWithRegionComponent.vue';
import reportPreview from './components/report/ReportPreviewComponent.vue';
import definitionOfIndicators from './components/report/modules/live-report/shared/DefinitionOfIndicatorsComponent.vue';
import indicatorPhases from './components/report/modules/live-report/shared/IndicatorPhasesComponent.vue';
import dataTrends from './components/report/modules/live-report/shared/DataTrendsComponent.vue';
import roc from './components/report/modules/live-report/shared/ROCComponent.vue';
import indicatorCompare from './components/report/modules/live-report/shared/IndicatorCompareComponent.vue';
import managementObjectives from './components/report/modules/live-report/shared/ManagementObjectivesComponent.vue';
import terminology from './components/report/modules/live-report/shared/TerminologyComponent.vue';
import forecast from './components/report/modules/live-report/shared/ForecastComponent.vue';
import outlook from './components/report/modules/live-report/shared/OutlookComponent.vue';
import timingModelGuide from './components/report/modules/live-report/shared/TimingModelGuideComponent.vue';
import divisionComparison from './components/report/modules/live-report/shared/DivisionComparisonComponent.vue';
import dashboardCardDeck from './components/dashboard/DashboardCardDeck.vue';
import dashboardCard from './components/dashboard/DashboardCard.vue';
import dashboardPDF from './components/report/modules/live-report/dashboard/DashboardPDFComponent.vue';
import dashboardBeforeYouGoPage from './pages/dashboard/dashboard-before-you-go-page.vue';
import customizedReportPDF from './components/report/modules/live-report/customized-report/CustomizedReportPDFComponent.vue';
import customizedReportFooter from './components/report/modules/live-report/customized-report/CRFooterComponent.vue';
import trendsReport from './components/trendsreport/TrendsReportIndexComponent.vue';
import trendsReportFiltered from './components/trendsreport/TrendsReportFiltered.vue';
import mfaModalPopup from './components/user/mfa/MFAModalPopupComponent.vue';
import setupMFA from './components/user/mfa/SetupMFAComponent.vue';
import sendMFA from './components/user/mfa/SendMFAComponent.vue';
import insiderHomePage from './pages/insider/insider-home-page.vue';
import businessSeriesWebinars from './components/insider/ProductPageComponent.vue';
import datasetsPage from './pages/dashboard/datasets/datasets-index.vue';
import datasetsUploadPage from './pages/dashboard/datasets/datasets-upload.vue';
import datasetsEditPage from './pages/dashboard/datasets/datasets-edit.vue';
import manageUsersAndPermissions from './pages/dashboard/manage-users-and-permissions.vue';
import manageUsersAndPermissionsCreate from './pages/dashboard/manage-users-and-permissions-create.vue';
import byTheNumbersProductPage from './pages/by-the-numbers/by-the-numbers-product-page.vue';
import byTheNumbersAnnouncementsPage from './pages/by-the-numbers/by-the-numbers-announcements-page.vue';
import byTheNumbersAnnouncementPage from './pages/by-the-numbers/by-the-numbers-announcement-page.vue';
import PollResultComponent from './components/presentations/PollResultComponent.vue';
import SubscriptionList from './components/dashboard/subscriptions/SubscriptionList.vue';
import TrendsreportHomePage from './pages/trendsreport/trendsreport-home-page.vue';
import TrendsReportROCTableChart from './components/trendsreport/TrendsReportROCTableChart.vue';
import TrendsReportDTTableChart from './components/trendsreport/TrendsReportDTTableChart.vue';
import SiteAlertConfirmation from './components/site/alerts/PocConfirmation.vue';
import SiteProductLogin from './components/site/SiteProductLogin.vue';
import CountryStateContainer from './components/dashboard/CountryStateContainer.vue';
import TrendsReportPDFComponent from './components/trendsreport/pdf/TrendsReportPDFComponent.vue';
import TRReportPreviewComponent from './components/report/TRReportPreviewComponent.vue';
import TrendsReportPDFCollection from './components/trendsreport/pdf/TrendsReportPDFCollection.vue';
import PasswordComponent from './components/user/PasswordComponent.vue';
import BaseTextBar from './components/base/BaseTextBar.vue';
import IconItrEye from './components/icon/IconItrEye.vue';
import AppAtAGlanceTable from './components/trendsreport/html/AtAGlanceComponents/AppAtAGlanceTable.vue';

// CREATE VUE 3 APP
const app = createApp({});

// REGISTER ALL COMPONENTS FROM VUE 3
app.component('flash', flash);
app.component('checkout-page', checkoutPage);
app.component('cart-item-count-component', cartItemCount);
app.component('cart-add-to-cart-component', cartAddToCart);
app.component('datacast-add-to-cart-component', dataCastAddToCart);
app.component('cart-component', cart);
app.component('click-to-edit', clickToEdit);
app.component('click-to-edit-password', clickToEditPassword);
app.component('request-password-change-component', requestPasswordChange);
app.component('user-billing-info', userBillingInfo);
app.component('pay-invoice-component', payInvoice);
app.component('contact-us-component', contactUs);
app.component('contact-customer-care-component', contactCustomerCare);
app.component('datacast-trial-list-component', datacastTrialList);
app.component('trends-report-trial-list-component', trendsReportTrialList);
app.component(
  'insider-leading-indicators-list-component',
  insiderLeadingIndicatorsList
);
app.component(
  'insider-cancellation-options-component',
  insiderCancellationOptions
);
app.component(
  'trendsreport-cancellation-options-component',
  trendsreportCancellationOptions
);
app.component(
  'datacast-cancellation-options-component',
  datacastCancellationOptions
);
app.component(
  'datacast-essentials-cancellation-options-component',
  datacastEssentialsCancellationOptions
);
app.component('new-user-experience-modal', newUserExperienceModal);
app.component('report-component', report);
app.component('app-report-component', appReport);
app.component('report-by-id-component', reportByID);
app.component('report-by-id-with-region-component', reportByIDWithRegion);
app.component('report-preview-component', reportPreview);
app.component('definition-of-indicators-component', definitionOfIndicators);
app.component('indicator-phases-component', indicatorPhases);
app.component('data-trends-component', dataTrends);
app.component('roc-component', roc);
app.component('indicator-compare-component', indicatorCompare);
app.component('management-objectives-component', managementObjectives);
app.component('terminology-component', terminology);
app.component('forecast-component', forecast);
app.component('outlook-component', outlook);
app.component('timing-model-guide-component', timingModelGuide);
app.component('division-comparison-component', divisionComparison);
app.component('dashboard-card-deck', dashboardCardDeck);
app.component('dashboard-card', dashboardCard);
app.component('dashboard-pdf-component', dashboardPDF);
app.component('customized-report-pdf-component', customizedReportPDF);
app.component('customized-report-footer', customizedReportFooter);
app.component('trends-report-component', trendsReport);
app.component('trends-report-filtered', trendsReportFiltered);
app.component('mfa-modal-popup-component', mfaModalPopup);
app.component('setup-mfa-component', setupMFA);
app.component('send-mfa-component', sendMFA);
app.component('insider-home-page', insiderHomePage);
app.component('business-series-webinars', businessSeriesWebinars);
app.component('datasets-page', datasetsPage);
app.component('datasets-upload-page', datasetsUploadPage);
app.component('datasets-edit-page', datasetsEditPage);
app.component('manage-users-and-permissions', manageUsersAndPermissions);
app.component(
  'manage-users-and-permissions-create',
  manageUsersAndPermissionsCreate
);
app.component('by-the-numbers-product-page', byTheNumbersProductPage);
app.component(
  'by-the-numbers-announcements-page',
  byTheNumbersAnnouncementsPage
);
app.component('by-the-numbers-announcement-page', byTheNumbersAnnouncementPage);
app.component('dashboard-before-you-go-page', dashboardBeforeYouGoPage);
app.component('poll-result-component', PollResultComponent);
app.component('subscription-list', SubscriptionList);
app.component('trendsreport-home-page', TrendsreportHomePage);
app.component('trendsreport-roc-table-chart', TrendsReportROCTableChart);
app.component('trendsreport-dt-table-chart', TrendsReportDTTableChart);
app.component('trends-report-pdf-component', TrendsReportPDFComponent);
app.component('tr-report-preview-component', TRReportPreviewComponent);
app.component('trends-report-pdf-collection', TrendsReportPDFCollection);
app.component('site-alert-poc-confirmation', SiteAlertConfirmation);
app.component('site-product-login', SiteProductLogin);
app.component('country-state-container', CountryStateContainer);
app.component('password-component', PasswordComponent);
app.component('base-text-bar', BaseTextBar);
app.component('icon-itr-eye', IconItrEye);
app.component('app-at-a-glance-table', AppAtAGlanceTable);

app.use(pinia);
app.mount('#main-page-wrapper');

//deteect touch on touch
window.USER_IS_TOUCHING = false;
window.addEventListener(
  'touchstart',
  function onFirstTouch() {
    // we could use a class
    document.body.classList.add('user-is-touching');
    // or set some global variable
    window.USER_IS_TOUCHING = true;
    // or set your app's state however you normally would
    // vue.dispatchEvent('USER_IS_TOUCHING', true);
    // we only need to know once that a human touched the screen, so we can stop listening now

    app.config.globalProperties.$emitter.emit('touch', window.USER_IS_TOUCHING);
    window.removeEventListener('touchstart', onFirstTouch, false);
  },
  false
);

window.USER_IS_ON_MOBILE_SAFARI = false;
window.mobilecheck = function () {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  window.USER_IS_ON_MOBILE_SAFARI = check;
  return;
};

//set user agent
var userAgent = window.navigator.userAgent;
if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
  window.USER_IS_ON_MOBILE_SAFARI = true;
}
if (userAgent.match(/Android/i) || userAgent.match(/webOS/i)) {
  window.USER_IS_ON_MOBILE_SAFARI = true;
}
